import './app.css';

import WebFont from 'webfontloader';
const analyticsEvent = require('./js/viscom/viscomjs/analytics/analyticsEvent');

/* is production */
const isProd = process.env.NODE_ENV === 'production';
const meta = require('./data/meta.json');

/* service worker */
if ('serviceWorker' in navigator && isProd) {
    window.addEventListener('load', () => {
        /* navigator.serviceWorker.register('./sw.js');*/
    });
}

/* analytics (EXAMPLE: analyticsEvent('Button', 'click', 'Play');) */
analyticsEvent('Page', 'load', 'Start');

/* fonts */
WebFont.load({
    custom: {
        families: ['Google Sans Display:n4,n6'],
        urls: ['./css/fonts.css']
    }
    /* ,
    google: {
        families: ['Roboto:400,700:cyrillic']
    },*/
    /*
    typekit: {
        id: 'xxxxxx'
    }*/
});

/* share buttons with lazyloading */
const shareButtonsContainer = document.querySelector('.share');
if (shareButtonsContainer !== null) {
    shareButtonsContainer.addEventListener('lazyloaded', () => {
        import(/* webpackPrefetch: true */ './js/viscom/viscomjs/ui/ShareButtons').then(func => {
            func(meta);
        });
    });
}

/* share expandable container buttons with lazyloading */
/* const shareContainer = document.querySelector('.share-expandable');
if (shareContainer !== null) {
    shareContainer.addEventListener('lazyloaded', () => {
        import(/!* webpackPrefetch: true *!/ './js/viscom/evraz/dynastyPromo/ui/shareListWithTrigger').then(func => {
            func.default();
        });
    });
}*/

/* webp pictures */
const webpElements = [...document.querySelectorAll('[data-webp][data-webp-fallback]')];
if (webpElements.length > 0) {
    import(/* webpackPrefetch: true */ './js/webp').then(func => {
        func.default(webpElements);
    });
}

import {TweenMax} from 'gsap';

/* const _isIEorEdge = () => {
    return navigator.appName === 'Microsoft Internet Explorer' || (navigator.appName === 'Netscape' && navigator.appVersion.indexOf('Edge') > -1);
};*/

{
    const startProject = () => {
        const preloader = require('./js/viscom/google/surviver/load/Preloader');
        const delay = isProd ? 100 : 1000;

        const startLoadTime = new Date().getTime();

        const ProjectPreload = require('./js/viscom/google/surviver/load/ProjectPreload');
        const map0 = require('./js/viscom/google/surviver/load/AnimationsMap0');
        const map1 = require('./js/viscom/google/surviver/load/AnimationsMap1');
        const svg0 = require('./js/viscom/google/surviver/load/SVGMap0');
        const svg1 = require('./js/viscom/google/surviver/load/SVGMap1');
        const startButton = document.querySelector('#startButton');

        const __loadProjectStart = () => {
            return ProjectPreload(preloader.update, map0, svg0());
        };

        const __loadProject = () => {
            return ProjectPreload(() => {}, map1, svg1);
        };

        const loaded = doThat => {
            return new Promise(resolve => {
                const t = new Date().getTime();
                const Project = require('./js/viscom/google/surviver/vue/ProjectVueApp');
                preloader.update({
                    progress: 100
                });

                const startProjectClick = () => {
                    Project.init();

                    TweenMax.delayedCall(0.01, () => {
                        // Project.start();
                        preloader.destroy();
                        startButton.removeEventListener('click', startProjectClick);
                        resolve(doThat);
                    });
                };

                TweenMax.delayedCall(Math.max(0, delay - (t - startLoadTime)) / 1000, () => {
                    startButton.removeAttribute('disabled');
                    startButton.addEventListener('click', startProjectClick);
                });
            });
        };

        __loadProjectStart()
            .then(loaded)
            .then(__loadProject);
    };

    startProject();
}
